import { Component, OnInit, Input, SimpleChanges, forwardRef } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { MarvSelectComponent, MarvSelectItem } from '@marv/components';
import { CustomerAreaService } from '@app/services';

@Component({
    selector: 'app-area-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [forwardRef(() => MarvSelectComponent)]
})
export class AreaSelectComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelSelect: string = this.translateService.instant('AREA');
    @Input({alias : 'icon', required : false}) iconSelect: string = 'map-outline';
    @Input({alias : 'formName', required : false}) formName: string|number = 'areaId';
    @Input({alias : 'errorText', required : false}) errorText: string = '';
    @Input({alias : 'multiple', required : false}) multiple: boolean = false; 
    @Input({alias : 'displayItemsSelected', required : false}) displayItemsSelected: boolean = false;
    @Input({alias : 'areas', required : false}) areas: Array<MarvSelectItem>;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;
    @Input({alias : 'hide', required : false}) hide: boolean = false;

    items: Array<MarvSelectItem> = [];

    constructor(
        public translateService: TranslateService
    ) { }

    async ngOnInit() {
        let items: Array<MarvSelectItem> = [];
        if(typeof this.areas !== 'undefined'){
            items = this.areas;
        }
        else{
            let areas = CustomerAreaService.Areas;
            if(areas && areas.length > 0){
                for(let area of areas){
                    items.push(new MarvSelectItem(area.name, area.id));
                }
            }
            else{
                this.hide = true;
            }
        }
        this.items = items;
    }
    
    async ngOnChanges(changes: SimpleChanges) {      
        if(changes['areas'] && changes['areas'].currentValue){ 
            if(typeof this.areas !== 'undefined'){
                this.items = this.areas;
            }
        }
    }
}
